import Vue from 'vue'
import { Subject, timer, from } from 'rxjs'
import { catchError, switchMap, map, filter } from 'rxjs/operators'

import repository from '@/repositories/Repository'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.queryNotification)
      this.$queryNotification = options.queryNotification
    else if (options.parent && options.parent.$queryNotification)
      this.$queryNotification = options.parent.$queryNotification
  },
})

const INTERVAL_MS = 3000
const RETRY_MAX = 5

let subject = new Subject()
let queryIdSubscription
let retryCount = 0

export default {
  connect(queryId) {
    if (queryIdSubscription) {
      queryIdSubscription.unsubscribe()
    }
    queryIdSubscription = timer(0, INTERVAL_MS)
      .pipe(
        switchMap(() => {
          return from(repository.giggle.get(`/api/query/${queryId}/status`))
        }),
        map(response => response.data),
        filter(queryStatus => queryStatus.status !== 'Working'),
      )
      .subscribe(
        queryStatus => {
          subject.next(queryStatus)
          queryIdSubscription.unsubscribe()
        },
        () => {
          // retry
          if (retryCount >= RETRY_MAX) {
            alert('サーバーに接続できませんでした。画面を再読込してください。')
            return
          }
          retryCount++
          this.connect(queryId)
        },
      )
  },
  observable: subject.asObservable().pipe(
    catchError(error => {
      // eslint-disable-next-line no-console
      console.warn(error)
      throw error
    }),
  ),
}
